import type { FC } from 'react';
import Home from './dashboard/home';
import { DataReview } from './admin/data-review';
import Users from './admin/user/user';
import Profile from './admin/profile/profile';
import Organizations from './platform-owner/organization/organizations';
import OrganizationSetup from './owner/organization-setup';
import Managers from './owner/manager/managers';
import Employees from './owner/employee/employees';
import MyOrganizations from './owner/my-organizations';
import MySubscription from './owner/my-subscription';
import RolesPermissions from './permissions/roles-permissions';
// NOTE: trash/app-config/email-config screens are wired back in when those
// sections are implemented — the files aren't built yet.
import Owners from './platform-owner/owner/owners';
import Owner from './platform-owner/owner/owner';
import OrganizationSubscriptions from './platform-owner/organization/organization-subscriptions';
import Plans from './platform-owner/plan/plans';
import Plan from './platform-owner/plan/plan';
import Brokers from './platform-owner/broker/brokers';
import Broker from './platform-owner/broker/broker';
import Revenue from './platform-owner/revenue/revenue';
import BrokerDashboard from './broker/dashboard';
import BrokerReferrals from './broker/referrals';
import BrokerProfile from './broker/profile';
import EmployeePortal from './employee/portal';
import Enterprise from './platform-owner/enterprise/enterprise';
import OrphanAssets from './platform-owner/orphan-assets';
import AboutPage from './settings/about';
import ContactPage from './settings/contact';
import PrivacyPage from './settings/privacy';
import TermsPage from './settings/terms';
import RateLimit from './settings/rate-limit';
import ApiUsage from './settings/api-usage';
import Trash from './settings/trash';
import AppConfigScreen from './settings/app-config';
import EmailConfigScreen from './settings/email-config';
import EmailTemplatesScreen from './settings/email-templates';
import Gallery from './settings/gallery';
import Preferences from './settings/preferences';

/**
 * Maps a route's `screen` key (from module-config) to a component.
 * Routes without a registered key fall back to <Placeholder /> in Layout.
 */
import { domainScreenRegistry } from './domain/registry';

export const screenRegistry: Record<string, FC> = {
  // This product's own screens — see screens/domain/registry.tsx. Spread first
  // so a platform key always wins a collision.
  ...domainScreenRegistry,
  home: Home,
  'data-review': DataReview,
  'users': Users,
  'profile': Profile,
  'organizations': Organizations,
  'organization-setup': OrganizationSetup,
  'managers': Managers,
  'employees': Employees,
  'my-organizations': MyOrganizations,
  'my-subscription': MySubscription,
  'roles-permissions': RolesPermissions,
  'owners': Owners,
  'owner': Owner,
  'organization-subscriptions': OrganizationSubscriptions,
  'plans': Plans,
  'plan': Plan,
  'brokers': Brokers,
  'broker': Broker,
  'revenue': Revenue,
  'broker-dashboard': BrokerDashboard,
  'broker-referrals': BrokerReferrals,
  'broker-profile': BrokerProfile,
  'employee-portal': EmployeePortal,
  'enterprise': Enterprise,
  'orphan-assets': OrphanAssets,
  'about-page': AboutPage,
  'contact-page': ContactPage,
  'privacy-page': PrivacyPage,
  'terms-page': TermsPage,
  'rate-limit': RateLimit,
  'api-usage': ApiUsage,
  'trash': Trash,
  'app-config': AppConfigScreen,
  'email-config': EmailConfigScreen,
  'email-templates': EmailTemplatesScreen,
  'gallery': Gallery,
  'preferences': Preferences,
};
